import { render, staticRenderFns } from "./ventafielTecnologiesCreate.vue?vue&type=template&id=9f8db79a&scoped=true&"
import script from "./ventafielTecnologiesCreate.vue?vue&type=script&lang=js&"
export * from "./ventafielTecnologiesCreate.vue?vue&type=script&lang=js&"
import style0 from "./ventafielTecnologiesCreate.vue?vue&type=style&index=0&id=9f8db79a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8db79a",
  null
  
)

export default component.exports